import BasicProfileCard from "components/Cards/basicProfileCard";
import JourneysCarousel from "components/CustomWidgets/journeysCarousel";
import React, { useContext } from "react";
import { useBlogList, useSuccessStories } from "hooks/api/useHome";
import { ExploreContext } from "context/ExploreContext";
import Skeleton from "components/BaseWidgets/skeleton";
import EmptyState from "components/BaseWidgets/emptyState";
import SubscriptionCard from "components/Cards/subscriptionCard";
import { usePremium } from "context/PremiumContext";
import PremiumCard from "components/Engage/components/PremiumModal";
import OverViewCarousal from "components/CustomWidgets/overViewCarousal";
import BlogCard from "components/Cards/blogCard";
import useMediaQuery from "hooks/useMediaQuery";
function GridCards({
  firstHalf,
  secondHalf,
  isListing,
  isNotInterested,
  tabActive,
  cardClassName,
  ActionChange,
  isCardShow,
  secondaryTabActive,
  selectedList,
  activeTab,
}) {
  const { isPremium } = usePremium();
  const { isLoading } = useContext(ExploreContext);
  const isMobile = useMediaQuery("(max-width: 820px)");
  const { data: stories = [], isLoading: isStoriesLoading } = useSuccessStories(
    {
      page: 1,
      limit: 6,
      see_all: false,
    },
  );
  const { data: blogData, isLoading: isBlogLoading } = useBlogList({
    see_all: true,
    request_type: 0,
  });
  const shouldShowCarousel = ["1", "3", "5"].includes(tabActive);
  const shouldRenderStories =
    !isNotInterested && !isStoriesLoading && !isListing && !isLoading;

  return (
    <>
      {isLoading ? (
        <div className="explore-card-grid">
          {Array.from({ length: 8 }).map((_, index) => (
            <Skeleton label={false} height={250} key={index} />
          ))}
        </div>
      ) : firstHalf?.length ? (
        <div className="explore-card-grid relative">
          {firstHalf.map((item) => (
            <BasicProfileCard
              profile={item}
              ActionChange={ActionChange}
              key={item.id}
              snippetProfileId={item.id}
              snippetProfileName={item.profileName}
              snippetImage={item.profileImage}
              snippetProfileAge={item.profileAge}
              snippetProfileHeight={item.profileHeight}
              snippetProfileJob={item.profileOcc}
              snipperVerification={item?.verificationType}
              snippetVisible={item.isShow && item.isPrivate}
              snippetInterestSent={item.isLike}
              snippetFav={item.isFav}
              snippetPremium={item.isPremium}
              snippetRecommended={item.isSuggest}
              snippetImageRequested={item?.image_request}
              isNotInterested={isNotInterested}
              contactReqByMe={item?.contactReqByMe}
              contactReqByOthers={item?.contactReqByOthers}
              photoReqByMe={item?.photoReqByMe}
              photoReqByOthers={item?.photoReqByOthers}
              aec_id={item?.aec_id}
              InterestReqByOthers={item?.interestReqByOthers}
              cardClassName={!isPremium ? cardClassName : ""}
              shareUrl={item?.shareUrl}
              secondaryTabActive={secondaryTabActive}
              tabVariant={tabActive}
              selectedList={selectedList}
              activeTab={activeTab}
            />
          ))}
          {isCardShow && <PremiumCard />}
        </div>
      ) : (
        <EmptyState className="overview-empty" />
      )}

      {shouldRenderStories &&
        (shouldShowCarousel ? (
          <>
            <JourneysCarousel
              successStories={stories}
              carousalResponsive={[
                { breakpoint: 1427, settings: { slidesToShow: 1.5 } },
                { breakpoint: 1277, settings: { slidesToShow: 1.2 } },
                { breakpoint: 1064, settings: { slidesToShow: 1 } },
                { breakpoint: 920, settings: { slidesToShow: 0.7 } },
                { breakpoint: 820, settings: { slidesToShow: 1.2 } },
                { breakpoint: 606, settings: { slidesToShow: 1 } },
              ]}
            />
            <OverViewCarousal
              isLoading={isBlogLoading}
              carousalClass="blog-carousal"
              cardTitle={isMobile ? "Match diaries" : "Blogs"}
              cardDesc="Explore our blogs to enhance your matchmaking experience."
              href="blog"
              autoplaySpeed={4000}
              autoplay={{ dotDuration: false }}
              slidesToShow={3}
              carousalData={blogData?.blog_data}
              renderItem={(item, i) => (
                <BlogCard key={i} blog={item} className="blog-card" />
              )}
              carousalResponsive={[
                { breakpoint: 1280, settings: { slidesToShow: 2.5 } },
                { breakpoint: 986, settings: { slidesToShow: 2 } },
                { breakpoint: 828, settings: { slidesToShow: 1.5 } },
                { breakpoint: 767, settings: { slidesToShow: 2.5 } },
                { breakpoint: 650, settings: { slidesToShow: 2 } },
                { breakpoint: 550, settings: { slidesToShow: 1.5 } },
              ]}
            />
          </>
        ) : (
          <SubscriptionCard
            title="Unlock premium matches – Find your perfect partner faster!"
            data={[
              "Profile boost & premium card",
              "Advanced search & filters",
              "Matchmaker insights",
              "Unlimited message",
            ]}
            btnText="See membership plans"
          />
        ))}

      {secondHalf?.length ? (
        <div className="explore-card-grid relative">
          {isLoading
            ? Array.from({ length: 8 }).map((_, index) => (
                <Skeleton label={false} height={250} key={index} />
              ))
            : secondHalf.map((item) => (
                <BasicProfileCard
                  profile={item}
                  key={item.id}
                  snippetProfileId={item.id}
                  snippetProfileName={item.profileName}
                  snippetImage={item.profileImage}
                  snippetProfileAge={item.profileAge}
                  snippetProfileHeight={item.profileHeight}
                  snippetProfileJob={item.profileOcc}
                  snipperVerification={item?.verificationType}
                  snippetVisible={item.isShow && item.isPrivate}
                  snippetInterestSent={item.isLike}
                  snippetFav={item.isFav}
                  snippetPremium={item.isPremium}
                  snippetRecommended={item.isSuggest}
                  snippetImageRequested={item?.image_request}
                  isNotInterested={isNotInterested}
                  isRequested={item?.isRequested}
                  aec_id={item?.aec_id}
                  cardClassName={!isPremium ? cardClassName : ""}
                  shareUrl={item?.shareUrl}
                  secondaryTabActive={secondaryTabActive}
                  tabVariant={tabActive}
                  selectedList={selectedList}
                />
              ))}
          {isCardShow && <PremiumCard showCard={false} />}
        </div>
      ) : null}
    </>
  );
}

export default GridCards;
